// A QR code drawn as SVG squares, with a two-module quiet zone: a share link's, the phone tile's.

import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

export function QR({ text, className = 'share-qr', label = 'QR code of the link', testid = 'share-qr' }: { text: string; className?: string; label?: string; testid?: string }) {
  const cells = useMemo(() => {
    const q = qrcode(0, 'M');
    q.addData(text);
    q.make();
    const n = q.getModuleCount();
    const out: string[] = [];
    for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (q.isDark(y, x)) out.push(`M${x + 2} ${y + 2}h1v1h-1z`);
    return { n: n + 4, d: out.join('') };
  }, [text]);
  return (
    <svg className={className} viewBox={`0 0 ${cells.n} ${cells.n}`} role="img" aria-label={label} data-testid={testid}>
      <rect width={cells.n} height={cells.n} />
      <path d={cells.d} />
    </svg>
  );
}
